export default "__VITE_ASSET__CTtWgJfp__"